import tags from '../tags';

const {
  elements: { cold, fire, physical, Lightning },
  skillTypes: {
    cc,
    dot,
    pet,
    cooldown,
    channeling,
    mobility,
    healing,
    toughness,
    damageBoost,
    resource,
    weaken,
  },
  skillTrees: { primary, secondary, defensive, might, tactics, rage },
} = tags;

export default [
  {
    name: 'Bash',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Frostbite',
        tags: [primary, cold, cc],
      },
      {
        name: 'Onslaught',
        tags: [primary, Lightning, weaken],
      },
      {
        name: 'Punish',
        tags: [primary, physical, damageBoost],
      },
      {
        name: 'Instigation',
        tags: [primary, fire, resource],
      },
      {
        name: 'Pulverize',
        tags: [primary, fire],
      },
    ],
  },
  {
    name: 'Hammer of the Ancients',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Rolling Thunder',
        tags: [secondary, physical],
      },
      {
        name: 'Smash',
        tags: [secondary, fire],
      },
      {
        name: 'The Devils Anvil',
        tags: [secondary, cold, cc],
      },
      {
        name: 'Thunderstrike',
        tags: [secondary, Lightning, cc],
      },
      {
        name: 'Birthright',
        tags: [secondary, physical, healing],
      },
    ],
  },
  {
    name: 'Cleave',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Rupture',
        tags: [primary, fire],
      },
      {
        name: 'Reaping Swing',
        tags: [primary, fire, resource],
      },
      {
        name: 'Scattering Blast',
        tags: [primary, physical, cc],
      },
      {
        name: 'Broad Sweep',
        tags: [primary, Lightning],
      },
      {
        name: 'Gathering Storm',
        tags: [primary, cold, cc, weaken],
      },
    ],
  },
  {
    name: 'Ground Stomp',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Deafening Crash',
        tags: [defensive, cold, cc],
      },
      {
        name: 'Wrenching Smash',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Trembling Stomp',
        tags: [defensive, fire, cc],
      },
      {
        name: 'Foot of the Mountain',
        tags: [defensive, physical, cc, resource],
      },
      {
        name: 'Jarring Slam',
        tags: [defensive, physical, cc, healing],
      },
    ],
  },
  {
    name: 'Rend',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical, dot],
      },
      {
        name: 'Ravage',
        tags: [secondary, fire, dot],
      },
      {
        name: 'Blood Lust',
        tags: [secondary, physical, dot, healing],
      },
      {
        name: 'Lacerate',
        tags: [secondary, Lightning, dot],
      },
      {
        name: 'Mutilate',
        tags: [secondary, cold, dot, cc, weaken],
      },
      {
        name: 'Bloodbath',
        tags: [secondary, physical, dot],
      },
    ],
  },
  {
    name: 'Leap',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Iron Impact',
        tags: [defensive, physical, cc, toughness],
      },
      {
        name: 'Launch',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Toppling Impact',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Call of Arreat',
        tags: [defensive, physical, cc],
      },
      {
        name: 'Death from Above',
        tags: [defensive, physical, cc],
      },
    ],
  },
  {
    name: 'Overpower',
    runes: [
      {
        name: 'No Rune',
        tags: [might, physical],
      },
      {
        name: 'Storm of Steel',
        tags: [might, physical],
      },
      {
        name: 'Killing Spree',
        tags: [might, Lightning, damageBoost],
      },
      {
        name: 'Crushing Advance',
        tags: [might, cold],
      },
      {
        name: 'Momentum',
        tags: [might, physical, resource],
      },
      {
        name: 'Revel',
        tags: [might, fire],
      },
    ],
  },
  {
    name: 'Frenzy',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Sidearm',
        tags: [primary, cold],
      },
      {
        name: 'Berserk',
        tags: [primary, cold, resource],
      },
      {
        name: 'Vanguard',
        tags: [primary, physical, resource],
      },
      {
        name: 'Smite',
        tags: [primary, Lightning, cc],
      },
      {
        name: 'Maniac',
        tags: [primary, fire, damageBoost],
      },
    ],
  },
  {
    name: 'Seismic Slam',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Stagger',
        tags: [secondary, Lightning, resource],
      },
      {
        name: 'Shattered Ground',
        tags: [secondary, fire, cc],
      },
      {
        name: 'Rumble',
        tags: [secondary, physical, dot],
      },
      {
        name: 'Strength from Earth',
        tags: [secondary, physical, healing],
      },
      {
        name: 'Permafrost',
        tags: [secondary, cold, cc],
      },
    ],
  },
  {
    name: 'Revenge',
    runes: [
      {
        name: 'No Rune',
        tags: [might, physical, healing],
      },
      {
        name: 'Blood Law',
        tags: [might, physical, healing],
      },
      {
        name: 'Best Served Cold',
        tags: [might, cold, damageBoost],
      },
      {
        name: 'Retribution',
        tags: [might, fire],
      },
      {
        name: 'Grudge',
        tags: [might, Lightning, cc],
      },
      {
        name: 'Provocation',
        tags: [might, physical],
      },
    ],
  },
  {
    name: 'Threatening Shout',
    runes: [
      {
        name: 'No Rune',
        tags: [tactics, physical, weaken],
      },
      {
        name: 'Intimidate',
        tags: [tactics, physical, weaken],
      },
      {
        name: 'Falter',
        tags: [tactics, physical, weaken],
      },
      {
        name: 'Grim Harvest',
        tags: [tactics, physical, healing],
      },
      {
        name: 'Demoralize',
        tags: [tactics, physical, cc],
      },
      {
        name: 'Terrify',
        tags: [tactics, physical, cc],
      },
    ],
  },
  {
    name: 'Sprint',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, physical, mobility, toughness],
      },
      {
        name: 'Rush',
        tags: [defensive, physical, mobility],
      },
      {
        name: 'Run Like the Wind',
        tags: [defensive, physical, mobility, dot],
      },
      {
        name: 'Marathon',
        tags: [defensive, physical, mobility],
      },
      {
        name: 'Gangway',
        tags: [defensive, physical, mobility, cc],
      },
      {
        name: 'Forced March',
        tags: [defensive, physical, mobility],
      },
    ],
  },
  {
    name: 'Weapon Throw',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Mighty Throw',
        tags: [primary, Lightning],
      },
      {
        name: 'Ricochet',
        tags: [primary, fire],
      },
      {
        name: 'Throwing Hammer',
        tags: [primary, physical, cc],
      },
      {
        name: 'Stupefy',
        tags: [primary, physical, cc],
      },
      {
        name: 'Balanced Weapon',
        tags: [primary, fire, resource],
      },
    ],
  },
  {
    name: 'Earthquake',
    runes: [
      {
        name: 'No Rune',
        tags: [rage, fire, dot],
      },
      {
        name: 'Giants Stride',
        tags: [rage, fire],
      },
      {
        name: 'Chilling Earth',
        tags: [rage, cold, cc],
      },
      {
        name: 'The Mountains Call',
        tags: [rage, Lightning, resource],
      },
      {
        name: 'Molten Fury',
        tags: [rage, fire],
      },
      {
        name: 'Cave-In',
        tags: [rage, physical, cc],
      },
    ],
  },
  {
    name: 'Whirlwind',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical, channeling],
      },
      {
        name: 'Dust Devils',
        tags: [secondary, physical, channeling],
      },
      {
        name: 'Hurricane',
        tags: [secondary, cold, cc, channeling],
      },
      {
        name: 'Blood Funnel',
        tags: [secondary, physical, healing, channeling],
      },
      {
        name: 'Wind Shear',
        tags: [secondary, Lightning, resource, channeling],
      },
      {
        name: 'Volcanic Eruption',
        tags: [secondary, fire, channeling],
      },
    ],
  },
  {
    name: 'Furious Charge',
    runes: [
      {
        name: 'No Rune',
        tags: [might, physical, mobility],
      },
      {
        name: 'Battering Ram',
        tags: [might, fire, mobility],
      },
      {
        name: 'Merciless Assault',
        tags: [might, physical, mobility, cooldown],
      },
      {
        name: 'Stamina',
        tags: [might, physical, mobility, resource],
      },
      {
        name: 'Cold Rush',
        tags: [might, cold, mobility, cc],
      },
      {
        name: 'Dreadnought',
        tags: [might, Lightning, mobility],
      },
    ],
  },
  {
    name: 'Ignore Pain',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, physical, toughness],
      },
      {
        name: 'Bravado',
        tags: [defensive, physical, toughness, mobility],
      },
      {
        name: 'Iron Hide',
        tags: [defensive, physical, toughness],
      },
      {
        name: 'Ignorance is Bliss',
        tags: [defensive, physical, toughness, healing],
      },
      {
        name: 'Mob Rule',
        tags: [defensive, physical, toughness],
      },
      {
        name: 'Contempt for Weakness',
        tags: [defensive, physical, toughness, healing],
      },
    ],
  },
  {
    name: 'Battle Rage',
    runes: [
      {
        name: 'No Rune',
        tags: [tactics, physical, damageBoost],
      },
      {
        name: 'Marauders Rage',
        tags: [tactics, physical, damageBoost],
      },
      {
        name: 'Ferocity',
        tags: [tactics, physical, damageBoost, mobility],
      },
      {
        name: 'Swords to Ploughshares',
        tags: [tactics, physical, damageBoost, healing],
      },
      {
        name: 'Into the Fray',
        tags: [tactics, physical, damageBoost],
      },
      {
        name: 'Bloodshed',
        tags: [tactics, physical, damageBoost],
      },
    ],
  },
  {
    name: 'Call of the Ancients',
    runes: [
      {
        name: 'No Rune',
        tags: [rage, physical, pet],
      },
      {
        name: 'The Council Rises',
        tags: [rage, fire, pet],
      },
      {
        name: 'Duty to the Clan',
        tags: [rage, cold, pet, cc, weaken],
      },
      {
        name: 'Ancients Blessing',
        tags: [rage, physical, pet, healing],
      },
      {
        name: 'Ancients Fury',
        tags: [rage, physical, pet, resource],
      },
      {
        name: 'Together as One',
        tags: [rage, Lightning, pet, toughness],
      },
    ],
  },
  {
    name: 'Ancient Spear',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Ranseur',
        tags: [secondary, physical, cc],
      },
      {
        name: 'Harpoon',
        tags: [secondary, physical, cc],
      },
      {
        name: 'Jagged Edge',
        tags: [secondary, fire],
      },
      {
        name: 'Boulder Toss',
        tags: [secondary, physical],
      },
      {
        name: 'Rage Flip',
        tags: [secondary, physical, cc],
      },
    ],
  },
  {
    name: 'War Cry',
    runes: [
      {
        name: 'No Rune',
        tags: [tactics, physical, toughness],
      },
      {
        name: 'Hardened Wrath',
        tags: [tactics, physical, toughness],
      },
      {
        name: 'Charge!',
        tags: [tactics, physical, toughness, resource],
      },
      {
        name: 'Invigorate',
        tags: [tactics, physical, toughness, healing],
      },
      {
        name: 'Veterans Warning',
        tags: [tactics, physical, toughness],
      },
      {
        name: 'Impunity',
        tags: [tactics, physical, toughness],
      },
    ],
  },
  {
    name: 'Wrath of the Berserker',
    runes: [
      {
        name: 'No Rune',
        tags: [rage, physical, damageBoost, toughness, mobility],
      },
      {
        name: 'Arreats Wail',
        tags: [rage, fire, damageBoost, toughness, mobility],
      },
      {
        name: 'Insanity',
        tags: [rage, physical, damageBoost, toughness, mobility],
      },
      {
        name: 'Slaughter',
        tags: [rage, physical, damageBoost, toughness, mobility],
      },
      {
        name: 'Striding Giant',
        tags: [rage, physical, damageBoost, toughness, mobility],
      },
      {
        name: 'Thrive on Chaos',
        tags: [rage, physical, damageBoost, toughness, mobility, healing],
      },
    ],
  },
  {
    name: 'Avalanche',
    runes: [
      {
        name: 'No Rune',
        tags: [might, physical],
      },
      {
        name: 'Volcano',
        tags: [might, fire, dot],
      },
      {
        name: 'Lahar',
        tags: [might, physical, cooldown],
      },
      {
        name: 'Snow-Capped Mountain',
        tags: [might, cold, cc],
      },
      {
        name: 'Tectonic Rift',
        tags: [might, physical],
      },
      {
        name: 'Glacier',
        tags: [might, cold, cc],
      },
    ],
  },
];
